// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2LDcI","row":"styles_row__29kXh"};